// extracted by mini-css-extract-plugin
export default {"label":"File_label__qU6YL","tooltip":"File_tooltip__BHAFc","wrap":"File_wrap__2soNk","input":"File_input__SBMKC","box":"File_box__MGu5d"};